import { NAV_ITEMS } from './nav-items';
import { SETTINGS_NODES } from '~/shared/api/settings-api';
import { SECTION_HREFS, canOpenSettingsNode, canSeeScreen, sectionFunctionOf } from '~/shared/access/sections';
import { holds } from '~/shared/lib/permission-implications';

export const sectionOf = (pathname: string): string | null => {
  let best: string | null = null;
  for (const href of SECTION_HREFS) {
    const inside = pathname === href || pathname.startsWith(`${href}/`);
    if (inside && (best === null || href.length > best.length)) best = href;
  }
  return best;
};

const DETAIL_PERMISSION: readonly { pattern: RegExp; section: string; permission: string }[] = [
  { pattern: /^\/clients\/(?!blacklist$)[^/]+$/, section: '/clients', permission: 'client:view_any' },
];

export const deniedSection = (pathname: string, permissions: readonly string[]): string | null => {
  const fn = sectionFunctionOf(pathname);
  if (fn) return holds(permissions, fn.permission) ? null : fn.section;
  const node = SETTINGS_NODES.find((n) => n.permission && n.href === pathname);
  if (node) return canOpenSettingsNode(node, permissions) ? null : '/settings';
  const detail = DETAIL_PERMISSION.find((d) => d.pattern.test(pathname));
  if (detail) return permissions.includes(detail.permission) || canSeeScreen(detail.section, permissions) ? null : detail.section;
  const section = sectionOf(pathname);
  return section !== null && !canSeeScreen(section, permissions) ? section : null;
};

export const sectionLabel = (href: string): string => NAV_ITEMS.find((i) => i.href === href)?.label ?? href;

export const firstOpenSection = (permissions: readonly string[]): string =>
  SECTION_HREFS.find((href) => canSeeScreen(href, permissions)) ?? '/';
